import { yup } from '@guiker/yup-util'

export const assetIdNested = yup.object({
  assetId: yup.string().required(),
})
